import React, { ReactNode, useEffect, useLayoutEffect, useRef, useState } from "react";


interface CoreFormProps {
    onSubmit?: (any) => void;
    onErrors?: (errorEvent: CoreFormErrors) => any;
    children?: ReactNode | undefined;
}


export const CoreForm = (props: CoreFormProps) => {

    const elementRef = useRef<HTMLFormElement>();
    let [errors, setErrors] = useState({});

    const onInpuptChanged = (event: CustomEvent<CoreValidationResults>) => {

        const name = event.detail.name;
        const group = event.detail.group;
        const results = event.detail.validationResults.filter(r => r.valid == false);


        if (results.length == 0) {
            delete errors[name];
        } else {
            let errorItem = { name, group, errors: results.map(r => r.error) };
            errors[name] = errorItem
        }
        props.onErrors && props.onErrors(errors);

        setErrors({ ...errors });



    }

    useLayoutEffect(() => {

        elementRef.current.addEventListener("core-input-validation", onInpuptChanged);
        return () => {
            elementRef.current.removeEventListener("core-input-validation", onInpuptChanged);
        }
    }, [])


    return (
        <form autoComplete="off" ref={elementRef} action="" className="flex flex-column flex-1">
            {props.children}
        </form>
    )

}